import { IMenuItemEntry } from '@move-frontend/contentful';
import { IOtherWebsitesEntry } from '../../../../contentful/types/IMenuItem';
import { Flex, ChevronLeftIcon } from '../../../../ui';

interface IMobileBackButtonProps {
	selectedItem?: IMenuItemEntry | IOtherWebsitesEntry;
}

export default function MobileBackButton({
	selectedItem,
}: IMobileBackButtonProps) {
	const title = selectedItem?.fields.title;
	if (selectedItem) {
		return (
			<Flex gap="8" alignItems="center">
				<ChevronLeftIcon aria-label="Go back" />
				{title}
			</Flex>
		);
	}
	return <div>Menu</div>;
}
